"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Commitment() {
  const shouldReduceMotion = useReducedMotion();
  const fadeInVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 24
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  return <section id="commitment" data-nav="light" className="
        relative
        text-foreground
        overflow-hidden
        !bg-[rgba(0,0,0,1)]
        pt-24
        pb-16
        sm:pt-28
        md:py-24
        lg:py-32
        font-switzer
      ">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">

        <div className="
            grid
            grid-cols-1
            lg:grid-cols-12
            gap-12
            lg:gap-16
            items-center
          ">

          {/* =====================================================
              COLUMNA DE TEXTO
           ===================================================== */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: "-50px"
        }} variants={fadeInVariants} className="
              lg:col-span-6
              flex
              flex-col
              justify-center
              space-y-6
            ">

            {/* Título */}
            <h2 className="
                text-3xl
                sm:text-4xl
                lg:text-5xl
                font-normal
                text-primary
                tracking-tight
              ">
              El compromiso
            </h2>

            {/* Texto */}
            <div className="
                space-y-4
                text-muted-foreground
                text-base
                sm:text-lg
                leading-relaxed
              ">
              <p className="
                  !text-[rgba(247,249,250,1)]
                  !text-justify
                ">
                El compromiso representa el acuerdo compartido entre la
                Comunión de las Asambleas de Dios Mundiales para participar
                en la plantación de iglesias, el evangelismo y el discipulado.
              </p>

              <p className="
                  !text-[rgba(245,245,246,1)]
                  !text-justify
                ">
                Los líderes que firman El compromiso afirman la visión
                colaborativa de MM33 y se comprometen a avanzar juntos en
                unidad para expandir el Reino.
              </p>
            </div>

            {/* =================================================
                NÚMERO
             ================================================= */}
            <div className="pt-2 pb-2">

              <span className="
                  block
                  text-3xl
                  sm:text-4xl
                  font-normal
                  text-primary
                  tracking-tight
                ">
                390.000
              </span>

              <span className="
                  text-sm
                  sm:text-base
                  text-muted-foreground
                ">
                <span className="!text-[rgba(238,240,244,1)]">
                  Iglesias y comunidades alcanzadas
                </span>
              </span>

            </div>

            {/* =================================================
                BOTÓN
             ================================================= */}
            <div className="pt-2">

              <Button asChild size="lg" className="
                  bg-primary
                  text-primary-foreground
                  hover:bg-primary/90
                  rounded-lg
                  px-8
                  py-3
                  text-base
                  font-normal
                  shadow-md
                  transition-colors
                  w-full
                  sm:w-auto
                  text-center
                ">
                <Link to="/AboutUsPage">
                  Nuestro compromiso
                </Link>
              </Button>

            </div>

          </motion.div>


          {/* =====================================================
              COLUMNA DE IMAGEN
              
              16:9
           ===================================================== */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: "-50px"
        }} variants={fadeInVariants} className="
              lg:col-span-6
              flex
              justify-center
              lg:justify-end
              w-full
            ">

            <div className="
                relative
                w-full
                aspect-video
                rounded-2xl
                overflow-hidden
                shadow-xl
                border
                border-border
              ">

              <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/commitment_soil_hands.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/commitment_soil_hands.webp-wvc-sizes" src="https://acadcr.org/wp-content/uploads/2026/08/MM33-Iglesia-Saludable-Asambleas-de-Dios-pptx-1-2048.webp" alt="Manos sosteniendo tierra fértil en señal de compromiso y plantación" loading="lazy" decoding="async" className="
                  absolute
                  inset-0
                  w-full
                  h-full
                  object-cover
                  object-center
                " />

            </div>

          </motion.div>

        </div>

      </div>
    </section>;
}